import { defineStore } from "pinia";
import type { MapStyleName } from "../map/mapTheme";

// Стиль подложки (меню «Слои»): наш или «Генштаб». Выбор - удобство
// конкретного браузера (localStorage), без бэкенда.
const STORAGE_KEY = "eco_map_style";

const load = (): { style: MapStyleName } => {
  try {
    return { style: localStorage.getItem(STORAGE_KEY) === "genshtab" ? "genshtab" : "default" };
  } catch {
    return { style: "default" };
  }
};

export const useMapStyleStore = defineStore("mapStyle", {
  state: load,
  actions: {
    set(style: MapStyleName) {
      this.style = style;
      try {
        localStorage.setItem(STORAGE_KEY, style);
      } catch {
        /* хранилище недоступно - выбор просто не переживёт перезагрузку */
      }
    },
  },
});
